import { useImagePreload } from '../../../../../hooks';
import { Box } from '../../../../../Box';
import { Skeleton } from '../../../../../Skeleton';
import { MediaEmpty } from '../../../../../MediaEmpty';

interface ImageComponentProps {
  alt: string;
  src: string;
  maxHeight: string;
  minHeight: string;
  width: string;
  hasError: boolean;
}

export const ImageComponent = ({
  alt,
  src,
  minHeight,
  maxHeight,
  width,
  hasError = false,
}: ImageComponentProps) => {
  const imageStatus = useImagePreload(src);

  const loadedImage = {
    loading: imageStatus === 'loading',
    fulfilled: imageStatus === 'complete',
    rejected: imageStatus === 'failed',
  };

  if (loadedImage.fulfilled) {
    return (
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={loadedImage.fulfilled ? 'bg.dark.primary' : 'bg.light.primary'}
        maxWidth={width}
        width="100%"
        overflow="hidden"
        radius="m"
      >
        <img
          src={src}
          alt={alt}
          style={{
            maxWidth: width,
            maxHeight,
            minHeight,
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  if (loadedImage.rejected || hasError) {
    return <MediaEmpty height={maxHeight} width={width} radius="m" />;
  }

  return <Skeleton height={maxHeight} width={width} variant="rect" />;
};
